import WhatsAppIcon from '../../components/WhatsAppIcon';

const WA_URL =
  "https://wa.me/5511986304696?text=Ol%C3%A1!%20Vim%20pelo%20site%20da%20l'ora%20e%20gostaria%20de%20uma%20proposta.";

const faqs = [
  {
    q: 'Posso contratar apenas um serviço?',
    a: 'Sim. Você pode contratar uma entrega pontual ou combinar serviços em um pacote. Quantidades e prazos ficam definidos na proposta.',
  },
  {
    q: 'Preciso saber falar na frente da câmera?',
    a: 'Não. Orientamos você durante a gravação e podemos incluir roteiro e direção para deixar sua fala mais natural.',
  },
  {
    q: 'Vocês editam vídeos que eu já gravei?',
    a: 'Sim. Avaliamos o material e alinhamos o estilo, os formatos e as entregas antes de começar.',
  },
  {
    q: 'Como recebo um orçamento?',
    a: 'Chame no WhatsApp e conte sobre seu projeto, o serviço desejado e o prazo. A partir disso, montamos uma proposta para você.',
  },
];

export default function Faq() {
  return (
    <section className="section wrap faq-section" id="duvidas">
      <div>
        <div className="eyebrow">Antes de começar</div>
        <h2>Dúvidas<br /><em>frequentes.</em></h2>
      </div>
      <div className="faq">
        {faqs.map(({ q, a }) => (
          <details key={q}>
            <summary>{q}</summary>
            <p>{a}</p>
          </details>
        ))}
        <a className="link" href={WA_URL} target="_blank" rel="noopener noreferrer">
          <WhatsAppIcon />
          <span>Tirar outra dúvida →</span>
        </a>
      </div>
    </section>
  );
}
